import React from "react"
import Image from "next/image"

import DisplayPrice from "@/UI/DataDisplay/DisplayPrice"
import { IQuote } from "@/types/quotes.types"
import { getKosmoNetworkDeliveryLabels } from "@/utils/delivery.utils"
import DeliveryOptionCardPickupDropoffETA from "./DeliveryOptionsCardPickupDropoff"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faClock } from "@fortawesome/free-solid-svg-icons"
import { vehicleImage } from "@/utils/providers"
import { Row } from "antd"

interface KosmoNetworkDeliveryOptionCardCompactProps {
  quote: IQuote
  selectedQuote?: IQuote | null
  onSelect: (selectedQuote: IQuote | null) => void
  selectionDisabled?: boolean
}

const KosmoNetworkDeliveryOptionCardCompact: React.FC<
  KosmoNetworkDeliveryOptionCardCompactProps
> = ({ quote, selectedQuote, onSelect, selectionDisabled }) => {
  return (
    <div
      className={`items-center py-2 px-2 cursor-pointer rounded-lg border min-w- ${
        quote.id === selectedQuote?.id ? "card-selected" : ""
      }
      ${selectionDisabled ? "bg-kosmoLightGray cursor-not-allowed" : ""}
      `}
      onClick={() => {
        if (!selectionDisabled) {
          onSelect(quote)
        }
      }}
    >
      <Row justify={"space-between"} className="w-full" align={"middle"}>
        <div className="flex gap-x-1.5 items-center">
          <Image width={20} height={20} src={vehicleImage(quote.vehicleType)} />
          <p className="font-medium">
            {getKosmoNetworkDeliveryLabels(quote.deliveryType, quote.pickupStartEta)}
          </p>
        </div>
        <span className="font-medium">
          <DisplayPrice
            isCents
            currencyCode={quote.priceBreakdown.currency}
            amount={quote.priceBreakdown.total}
            justify="center"
          />
        </span>
      </Row>
      <Row justify={"space-between"} className="w-full" align={"middle"}>
        <div className="flex justify-end" style={{ fontSize: 11 }}>
          <DeliveryOptionCardPickupDropoffETA
            deliveryType={quote.deliveryType}
            quote={quote}
            type="pickup"
          />
        </div>
        <div className="flex gap-x-1 items-center justify-end" style={{ fontSize: 11 }}>
          <FontAwesomeIcon className="flex flex-shrink-0 text-sm text-gray-400" icon={faClock} />
          <DeliveryOptionCardPickupDropoffETA
            deliveryType={quote.deliveryType}
            quote={quote}
            type="dropoff"
          />
        </div>
      </Row>
    </div>
  )
}

export default KosmoNetworkDeliveryOptionCardCompact
